import { FC, JSX } from "react";
import { Container, Heading, Section, Text } from "@radix-ui/themes";
import { useUpdateProfile } from "@/features/profile/hooks/useUpdateProfile";
import { countriesList } from "@/features/profile/constants/countries";
import { eligibleCountries } from "@/features/profile/constants/eligibleCountries";
import ProfileForm from "@/features/profile/components/ProfileForm/ProfileForm";
import { ProfileOnboarding } from "@/models/Profile.model";

const OnboardingPage: FC = (): JSX.Element => {
  const { onboardProfile, loading, error } = useUpdateProfile();

  const initialValues: ProfileOnboarding = {
    firstName: null,
    lastName: null,
    nationality: countriesList.userCountryCode,
    countryOfResidence: eligibleCountries.userCountryCode,
    dateOfBirth: null,
    gender: null,
    phoneNumber: "",
  };

  return (
    <>
      <Container px={{ initial: "4", lg: "0" }}>
        <Section size="1">
          <Heading as="h2">Onboarding</Heading>
          <Text as="p">
            Before continuing we would like you to answer a few questions about
            yourself.{" "}
          </Text>
        </Section>

        <Section size="1">
          <ProfileForm
            initialValues={initialValues}
            onSubmit={onboardProfile}
            loading={loading}
            error={error}
            submitButtonText="Submit"
          />
        </Section>
      </Container>
    </>
  );
};

export default OnboardingPage;
